module.exports = __webpack_public_path__ + "img/BetEnviosTransp.44f6cb8a.png";